import {  ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { FlightOffer } from '@app/models/offers/FlightOffer';
import { Subject, takeUntil } from 'rxjs';
import { FlugDetailComponent } from '../../modals/flugdetail/flugdetail.component';
interface Flug {
    directFlug: boolean;
    stopovers: string;
    differenceInDays: string;
    departureAirportName: string;
    estimatedElapsedTime: string;
    departureAirportCode: string;
    departureTime: string;
    departureDate: string;
    departureDateWeek: string;
    arrivalTime: string;
    travelClass: string;
    arrivalDate: string;
    tariff: string;
    bookingClass: string;
    arrivalDateWeek: string;
    arrivalAirportName: string;
    arrivalAirportCode: string;
}
interface Flights {
    outbound: Flug;
    inbound: Flug;
}
@Component({
    selector: 'clever-flugdata',
    templateUrl: './flugdata.component.html',
    styleUrls: ['./flugdata.component.scss'],
    standalone: false
})
export class FlugdataComponent implements OnInit, OnChanges, OnDestroy {
    @Input() flightOffer: FlightOffer;
    @Input() mode: string = 'pauschal';
    protected unsubscribe$ = new Subject();
    myflight: Flights;
    desktopTemplate: string = 'xl';
    weeks = [
        'SO.',
        'MO.',
        'DI.',
        'MI.',
        'DO.',
        'FR.',
        'SA.',
    ];

    constructor(
        protected dialog: MatDialog,
        protected cdr: ChangeDetectorRef,
        protected mediaObserver: BreakpointObserver,
    ) { }

    ngOnInit(): void {
        this.initMedia();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initData();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initMedia(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    initData(): void {
        this.myflight = {
            inbound: {} as Flug,
            outbound: {} as Flug,
        }
        if (this.flightOffer?.flight?.inbound) {
            this.myflight.inbound.directFlug = this.flightOffer?.flight?.inboundDirectFlight !== 'false';
            this.myflight.inbound.stopovers = this.flightOffer?.flight?.inbound?.stopovers;
            this.myflight.inbound.tariff = this.flightOffer?.flight?.inbound?.tariff;
            this.myflight.inbound.bookingClass = this.flightOffer?.flight?.inbound?.bookingClass;
            this.myflight.inbound.estimatedElapsedTime = this.flightOffer?.flight?.inbound?.estimatedElapsedTime;
            if (this.flightOffer?.flight?.inbound?.legList?.length > 0) {
                const length = this.flightOffer.flight.inbound?.legList.length;
                this.myflight.inbound.departureTime = this.flightOffer?.flight?.inbound?.legList[0].departureTime;
                this.myflight.inbound.departureDate = this.flightOffer?.flight?.inbound?.legList[0].departureDate;
                this.myflight.inbound.departureDateWeek = this.weeks[new Date(this.flightOffer?.flight?.inbound?.legList[0].departureDate).getDay()];
                this.myflight.inbound.departureAirportCode = this.flightOffer?.flight?.inbound?.legList[0].departureAirportCode;
                this.myflight.inbound.departureAirportName = this.flightOffer?.flight?.inbound?.legList[0].departureAirportName;
                // arrival
                this.myflight.inbound.arrivalTime = this.flightOffer?.flight?.inbound?.legList[length - 1].arrivalTime;
                this.myflight.inbound.arrivalDate = this.flightOffer?.flight?.inbound?.legList[length - 1].arrivalDate;
                this.myflight.inbound.arrivalDateWeek = this.weeks[new Date(this.flightOffer?.flight?.inbound?.legList[0].arrivalDate).getDay()];
                this.myflight.inbound.arrivalAirportCode = this.flightOffer?.flight?.inbound?.legList[length - 1].arrivalAirportCode;
                this.myflight.inbound.arrivalAirportName = this.flightOffer?.flight?.inbound?.legList[length - 1].arrivalAirportName;
            }
            if (this.myflight.inbound.departureDate?.length > 0 && this.myflight.inbound.arrivalDate?.length > 0) {
                const Difference_In_Time = new Date(this.myflight.inbound.arrivalDate).getTime() - new Date(this.myflight.inbound.departureDate).getTime();
                this.myflight.inbound.differenceInDays = Difference_In_Time > 0 ? (Difference_In_Time / (1000 * 3600 * 24)) + '' : '';
            }
        } else {
            this.myflight.inbound = null;
        }

        this.myflight.outbound.directFlug = this.flightOffer?.flight?.outboundDirectFlight !== 'false';
        this.myflight.outbound.stopovers = this.flightOffer?.flight?.outbound?.stopovers;
        this.myflight.outbound.tariff = this.flightOffer?.flight?.outbound?.tariff;
        this.myflight.outbound.bookingClass = this.flightOffer?.flight?.outbound?.bookingClass;
        this.myflight.outbound.estimatedElapsedTime = this.flightOffer?.flight?.outbound?.estimatedElapsedTime;
        if (this.flightOffer?.flight?.outbound?.legList?.length > 0) {
            const length = this.flightOffer.flight.outbound?.legList?.length;
            this.myflight.outbound.departureTime = this.flightOffer?.flight?.outbound?.legList[0].departureTime;
            this.myflight.outbound.departureDate = this.flightOffer?.flight?.outbound?.legList[0].departureDate;
            this.myflight.outbound.departureDateWeek = this.weeks[new Date(this.flightOffer?.flight?.outbound?.legList[0].departureDate).getDay()];
            this.myflight.outbound.departureAirportCode = this.flightOffer?.flight?.outbound?.legList[0].departureAirportCode;
            this.myflight.outbound.departureAirportName = this.flightOffer?.flight?.outbound?.legList[0].departureAirportName;

            // arrival
            this.myflight.outbound.arrivalTime = this.flightOffer?.flight?.outbound?.legList[length - 1].arrivalTime;
            this.myflight.outbound.arrivalDate = this.flightOffer?.flight?.outbound?.legList[length - 1].arrivalDate;
            this.myflight.outbound.arrivalDateWeek = this.weeks[new Date(this.flightOffer?.flight?.outbound?.legList[0].arrivalDate).getDay()];
            this.myflight.outbound.arrivalAirportCode = this.flightOffer?.flight?.outbound?.legList[length - 1].arrivalAirportCode;
            this.myflight.outbound.arrivalAirportName = this.flightOffer?.flight?.outbound?.legList[length - 1].arrivalAirportName;
        }

        if (this.myflight.outbound.departureDate?.length > 0 && this.myflight.outbound.arrivalDate?.length > 0) {
            const Difference_In_Time = new Date(this.myflight.outbound.arrivalDate).getTime() - new Date(this.myflight.outbound.departureDate).getTime();
            this.myflight.outbound.differenceInDays = Difference_In_Time > 0 ? (Difference_In_Time / (1000 * 3600 * 24)) + '' : '';
        }
        this.cdr.detectChanges();
    }

    async openFluginfo() {
        let target: any = { data: { flightOffer: this.flightOffer, mode: this.mode }, autoFocus: false };
        if (this.desktopTemplate === 'xs') {
            target = { data: { flightOffer: this.flightOffer, mode: this.mode, mobile: true }, autoFocus: false, width: '100%', height: '100%', maxWidth: '100%', maxHeight: '100vh' };
        }
        this.dialog.open(FlugDetailComponent, target);
    }
}
